export default __webpack_public_path__ + "e610c53f4e01f14bf52be7ac99facd2a.svg";